import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import EmptyFolderImg from './img/folder.png';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    padding: 12,
  },
  wrapper: {
    padding: 24,
    border: `dashed 1px ${palette.cncUI.default.primary}`,
    backgroundColor: palette.cncUI.default['+10'],
  },
  container: {
    width: 237,
    maxWidth: 237,
    height: 237,
    backgroundColor: palette.cncUI.default['+9'],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
    color: palette.cncUI.default.primary,
    width: 300,
  },
}));

const EmptyFolder = ({ type, country = 'US' }) => {
  const classes = useStyles();
  const title = country === 'CAN' ? 'TD1' : 'W-4';
  return (
    <Grid
      container
      spacing={2}
      className={classes.root}
      id={`EmptyList-${type}-${title.replace('-', '')}`}
    >
      <Grid item xs={12}>
        <Grid
          container
          spacing={2}
          justify="center"
          className={classes.wrapper}
        >
          <Grid item xs={12} className={classes.container}>
            <img alt="Empty Folder" src={EmptyFolderImg} />
            <Typography variant="h4" size="medium" className={classes.text}>
              {`No ${type} ${title}s to show.`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmptyFolder;
